(() => {
  // guard: если случайно подключили дважды
  if (window.__lokatorStickyAtcSimpleV3) return;
  window.__lokatorStickyAtcSimpleV3 = true;

  const MQ = window.matchMedia("(max-width: 749px)");
  const MIN_SCROLL_Y = 120;
  const BOTTOM_MARGIN = 140;

  let stickyEl = null;
  let stickyBtn = null;
  let stickySpinner = null;

  let host = null;
  let form = null;
  let mainBtn = null;

  let raf = 0;

  function isDrawerOpen() {
    return document.body.classList.contains("overflow-hidden");
  }

  function cleanup() {
    document.querySelectorAll(".sticky-atc[data-sticky='1']").forEach(el => el.remove());
    document.body.classList.remove("has-sticky-atc");
    stickyEl = stickyBtn = stickySpinner = null;
    host = form = mainBtn = null;
  }

  function findHost() {
    return document.querySelector("product-form.product-form");
  }

  function findForm(h) {
    if (!h) return null;
    return (
      h.querySelector('form[data-type="add-to-cart-form"]') ||
      h.querySelector("form[action*='/cart/add']") ||
      h.querySelector("form")
    );
  }

  function findMainBtn(h) {
    if (!h) return null;
    return (
      h.querySelector('form[data-type="add-to-cart-form"] button[name="add"]') ||
      h.querySelector("form[action*='/cart/add'] button[name='add']") ||
      h.querySelector("button[id^='ProductSubmitButton-'][name='add']")
    );
  }

  // ----- Color scheme from product area -----
  function findColorSchemeClass(el) {
    let node = el;
    while (node && node !== document.documentElement) {
      if (node.classList) {
        for (const c of node.classList) {
          if (c.startsWith("color-")) return c;
        }
      }
      node = node.parentElement;
    }
    return null;
  }

  function hasGradient(el) {
    let node = el;
    while (node && node !== document.documentElement) {
      if (node.classList && node.classList.contains("gradient")) return true;
      node = node.parentElement;
    }
    return false;
  }

  function applyScheme(sticky, reference) {
    if (!sticky || !reference) return;

    for (const c of Array.from(sticky.classList)) {
      if (c.startsWith("color-")) sticky.classList.remove(c);
    }
    sticky.classList.remove("gradient");

    const scheme = findColorSchemeClass(reference);
    if (scheme) sticky.classList.add(scheme);
    if (hasGradient(reference)) sticky.classList.add("gradient");
  }

  // ----- Price text (as-is from DOM) -----
  function getPriceText(h) {
    if (!h) return "";
    const sectionId = h.getAttribute("data-section-id");
    const scope =
      (sectionId && document.getElementById(`shopify-section-${sectionId}`)) ||
      h.closest("section") ||
      h.parentElement ||
      document;

    const sale = scope.querySelector(".price-item--sale.price-item--last");
    const reg = scope.querySelector(".price-item--regular");

    const t1 = (sale?.textContent || "").replace(/\s+/g, " ").trim();
    if (t1) return t1;

    const t2 = (reg?.textContent || "").replace(/\s+/g, " ").trim();
    return t2 || "";
  }

  function getMainLabel(btn) {
    if (!btn) return "Add to cart";
    const span = btn.querySelector("span");
    const t = (span ? span.textContent : btn.textContent) || "Add to cart";
    return t.replace(/\s+/g, " ").trim();
  }

  function setStickyLabel(label, price) {
    const span = stickyBtn?.querySelector("span");
    if (!span) return;
    span.textContent = price ? `${label} • ${price}` : label;
  }

  // ----- Loading state (spinner) -----
  function setLoading(isLoading) {
    if (!stickyBtn) return;

    // Dawn обычно использует класс loading; добавим его тоже
    stickyBtn.classList.toggle("loading", !!isLoading);

    if (stickySpinner) {
      stickySpinner.classList.toggle("hidden", !isLoading);
    }
  }

  // Patch fetch ONCE: show spinner while /cart/add request runs
  function patchFetchOnce() {
    if (window.__lokatorStickyAtcFetchPatchedV3) return;
    window.__lokatorStickyAtcFetchPatchedV3 = true;

    const origFetch = window.fetch;
    if (typeof origFetch !== "function") return;

    window.fetch = function (input, init) {
      try {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const method =
          ((init && init.method) ||
            (typeof input !== "string" && input && input.method) ||
            "GET").toUpperCase();

        const isAdd = url && url.includes("/cart/add");
        if (isAdd && method === "POST") setLoading(true);

        const p = origFetch.apply(this, arguments);
        return p.finally(() => {
          if (isAdd && method === "POST") setLoading(false);
        });
      } catch (_) {
        return origFetch.apply(this, arguments);
      }
    };
  }

  // Клон кнопки = оригинальная разметка (включая spinner), но “обезвреженная”
  function buildStickyButtonFrom(main) {
    const btn = main.cloneNode(true);

    // КРИТИЧНО: не даём Dawn считать это настоящей ATC-кнопкой
    btn.type = "button";
    btn.removeAttribute("name");         // убираем name="add"
    btn.removeAttribute("id");
    btn.removeAttribute("form");
    btn.removeAttribute("aria-haspopup");

    // На всякий случай: если у темы есть делегаты по data-атрибутам
    btn.setAttribute("data-sticky-clone", "1");

    const spinner = btn.querySelector(".loading__spinner");
    if (spinner) spinner.classList.add("hidden"); // по умолчанию скрыт

    return { btn, spinner };
  }

  function ensure() {
    if (!MQ.matches) return false;

    host = findHost();
    if (!host) return false;

    form = findForm(host);
    mainBtn = findMainBtn(host);

    if (!form || !mainBtn) return false;

    if (!stickyEl) {
      patchFetchOnce();

      stickyEl = document.createElement("div");
      stickyEl.className = "sticky-atc";
      stickyEl.setAttribute("data-sticky", "1");
      document.body.appendChild(stickyEl);

      const built = buildStickyButtonFrom(mainBtn);
      stickyBtn = built.btn;
      stickySpinner = built.spinner;

      stickyEl.appendChild(stickyBtn);

      stickyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        // обновим ссылки на случай перерендера
        const h = findHost();
        const f = findForm(h);
        const btn = findMainBtn(h);
        if (!h || !f || !btn) return;
        if (btn.disabled) return;
        if (isDrawerOpen()) return;

        // Включаем спиннер сразу
        setLoading(true);

        // инициируем add-to-cart "как Dawn"
        if (typeof f.requestSubmit === "function") f.requestSubmit(btn);
        else btn.click();
      });
    }

    applyScheme(stickyEl, host);
    return true;
  }

  function mainButtonVisible() {
    if (!mainBtn) return true;
    const r = mainBtn.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < (vh - BOTTOM_MARGIN);
  }

  function show() {
    if (!stickyEl) return;
    stickyEl.classList.add("is-visible");
    document.body.classList.add("has-sticky-atc");
  }

  function hide() {
    if (!stickyEl) return;
    stickyEl.classList.remove("is-visible");
    document.body.classList.remove("has-sticky-atc");
    setLoading(false);
  }

  function tick() {
    raf = 0;

    if (!MQ.matches) {
      hide();
      return;
    }

    if (isDrawerOpen()) {
      hide();
      return;
    }

    if (!ensure()) return;

    // если тема перерисовала кнопку — переподхват
    if (mainBtn && !mainBtn.isConnected) {
      host = findHost();
      form = findForm(host);
      mainBtn = findMainBtn(host);
      if (!host || !form || !mainBtn) {
        hide();
        return;
      }
      applyScheme(stickyEl, host);
    }

    // синхронизируем disabled и классы (для корректной схемы кнопки)
    stickyBtn.disabled = !!mainBtn.disabled;

    // обновляем label + price
    const label = getMainLabel(mainBtn);
    const price = getPriceText(host);
    setStickyLabel(label, price);

    if (window.scrollY < MIN_SCROLL_Y) {
      hide();
      return;
    }

    if (mainButtonVisible()) hide();
    else show();
  }

  function requestTick() {
    if (raf) return;
    raf = requestAnimationFrame(tick);
  }

  function init() {
    cleanup();
    ensure();
    requestTick();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("scroll", requestTick, { passive: true });
  window.addEventListener("resize", requestTick);
  MQ.addEventListener?.("change", init);

  document.addEventListener("change", (e) => {
    if (e.target && e.target.closest && e.target.closest("product-form.product-form")) {
      requestTick();
    }
  });

  document.addEventListener("shopify:section:load", init);
})();